export const CONTACTS_CODES = {
    PHONE_CODE: 'phone',
    FAX_CODE: 'fax',
    WEB_CODE: 'www',
    EMAIL_CODE: 'email',
    GREEN_LINE_CODE: 'greenLine',
    DATA_BOX_CODE: 'dataBox',
}

export const DATA_BOX_PREFIX = 'https://www.mojedatovaschranka.cz/sds/detail.do?dbid='
